import React, { createContext, useContext } from 'react';
import useMemberPlan from '@src/hooks/useMemberPlan';
import { MemberPlan, UserPlanResponse } from '@src/graphql/home/queries/getUserPlan';

interface MemberPlanContextInterface {
  loading?: boolean;
  error?: any;
  memberPlan?: MemberPlan | null;
  programIds?: string[] | [];
  planData?: UserPlanResponse;
}

const MemberPlanContext = createContext<MemberPlanContextInterface>({
  memberPlan: null,
  programIds: [],
});

const MemberPlanProvider: React.FC = ({ children }) => {
  const { error, loading, memberPlan, programIds, planData } = useMemberPlan();
  return (
    <MemberPlanContext.Provider
      value={{
        error,
        loading,
        memberPlan,
        programIds,
        planData,
      }}
    >
      {children}
    </MemberPlanContext.Provider>
  );
};

const useMemberPlanContext = () => useContext(MemberPlanContext);

export default MemberPlanProvider;

export { useMemberPlanContext, MemberPlanContext, MemberPlanProvider, MemberPlanContextInterface };
